import { atom } from 'recoil';
import { NGASearchResult } from '../components/Widgets/ArtGallery/ArtGallery.state';
import { IWidget } from '../components/Widgets/type';

export const aSelectedArtwork = atom<NGASearchResult | null>({
    key: 'aSelectedArtwork',
    default: null
});

export const aCreateOrUpdateWidget = atom<'create' | 'update'>({
    key: 'aCreateOrUpdateWidget',
    default: 'create'
});

export const aEditedWidget = atom<IWidget | null>({
    key: 'aEditedWidget',
    default: null
});

//! remove later(only being used in previous-RoomCallController.view.tsx)
export const aShowPersonalMeetingCorner = atom<boolean>({ key: 'aShowPersonalMeetingCorner', default: false });

export const aTypeOfPersonalRoomTable = atom<'desk' | 'meeting-table'>({ key: 'aTypeOfPersonalRoomTable', default: 'desk' });

export const aDisplayCreateWidgetModal = atom<'art-gallery' | 'image-upload' | 'quote' | 'book' | 'urls' | 'another-life' | ''>({
    key: 'aDisplayCreateWidgetModal',
    default: ''
});

export const aTopImageIndex = atom<number>({ key: 'aTopImageIndex', default: 0 });
export const aBottomImageIndex = atom<number>({ key: 'aBottomImageIndex', default: 0 });

export const aWidgetsList = atom<IWidget[]>({ key: 'aWidgetsList', default: [] });

export const aCurrentWidgetIndex = atom<number>({ key: 'aCurrentWidgetIndex', default: 0 });

export const aIsBottomImageExpanded = atom<boolean>({ key: 'aIsBottomImageExpanded', default: true });

export const aIsMeetingCornerSettingLoadedFromDB = atom<boolean>({ key: 'aIsMeetingCornerSettingLoadedFromDB', default: false });
